//api/associate/companies
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssociateCompanyService {
  private URL = environment.api + "api/associate";
  constructor(
    private http: HttpClient
  ) { }

  /**
   * This endpoint returns an not authorizated message
   * @returns 
   */
  getAssociateCompanies(){
	return this.http.get(this.URL + "/companies");
  }

  /**
   * This endpoint returns an not authorizated message
   * @returns 
   */
  getCommission(){
	return this.http.get(this.URL + "/companies/commission");
  }

}